import { render, staticRenderFns } from "./TemplateFiveList.vue?vue&type=template&id=c4b2db88&scoped=true"
import script from "./TemplateFiveList.vue?vue&type=script&lang=js"
export * from "./TemplateFiveList.vue?vue&type=script&lang=js"
import style0 from "./TemplateFiveList.vue?vue&type=style&index=0&id=c4b2db88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b2db88",
  null
  
)

export default component.exports